import { Typography } from 'antd';
import { Breakpoints } from 'logic/hooks/use-breakpoints';
import { MainContent } from 'src/pages-all/master-page/components/main-content';
import styled from 'styled-components';
import { colors } from 'styles/colors';
import tw from 'twin.macro';

export const HeadingPublishOffer = styled(Typography.Title)`
  &.ant-typography {
    font-size: 20px;
    font-weight: 600;
    color: ${colors.gray3};
    margin-bottom: 20px;
    width: 100%;
  }
`;

export const HeadingPublishOfferContainer = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
`;

export const OfferFormMainContent = styled(MainContent)`
  flex-direction: row;
  display: flex;
`;

export const OfferFormPaddingWrapper = styled.div`
  ${tw`px-4 py-8 md:px-8 lg:px-20`}

  @media (${Breakpoints.minTablet}) {
    padding-right: 85px;
    padding-left: 85px;
  }
`;

export const OfferFormInfoBoxesPlaceholder = styled.div`
  display: none;
  @media (${Breakpoints.minDesktop}) {
    display: block;
    width: 280px;
    height: 100%;
  }
`;

const BackIconWrapper = styled.div`
  ${tw`flex items-center content-start mb-4`}
`;

// @ts-ignore
export const OfferFormButtonContainer = styled.div`
  ${tw`flex items-center content-center`}
  flex: 1;

  .ant-row.ant-form-item {
    ${tw`flex items-center content-center`}
    flex: 1;
    margin-bottom: 0;
    margin-right: 16px;
    align-self: flex-end;
    align-content: flex-end;
  }

  .ant-btn.ant-btn-link {
    margin-left: -16px;
  }

  a {
    width: 100%;
    ${BackIconWrapper} {
      ${tw`flex items-center content-center`}
      justify-content:center;
      flex: 1;
    }
  }
`;

export const OfferFormContent = styled.div`
  background-color: ${colors.white};
  max-width: 860px;

  @media (${Breakpoints.maxTablet}) {
    margin: 0 auto;
  }

  @media (${Breakpoints.minDesktop}) {
    flex: 3;
  }
`;

export const OfferFormDivider = styled.div`
  border-top: 1px solid black;
  height: 1px;
`;

export const OfferFormSectionWrapper = styled.div`
  padding-top: 35px;
  padding-bottom: 35px;
  position: relative;
`;
